<div class="p-2">
  <div class="fs-4 mb-2">Mobile Forms</div>
  <div class="mb-2 d-inline-flex flex-column">
    <div class="d-flex gap-3 flex-column">
      <div>
        Replace paper logs with structured forms. Guards can submit reports from
        the field even offline with all data syncing to your dashboard in real
        time.
      </div>

      <div>
        This provides accurate, consistent information, eliminates manual entry,
        and creates a clear digital record for compliance and oversight.
      </div>
    </div>
  </div>

  <div class="d-flex flex-column flex-sm-row input-btn-group my-2">
    <div class="mb-2 me-sm-2 col-lg-2">
      <button class="btn btn-primary btn-lg w-100" routerLink="/mobile-form">
        + Add Mobile Form
      </button>
    </div>
    @if (initialTotalUserPromptCount > 5) {
      <div class="mb-2 flex-sm-grow-1" id="filterCheckpoint">
        <gtapp-auto-complete
          [data]="userPromptDropDownList"
          placeHolder="Search Mobile Form"
          searchKeyword="name"
          [itemTemplate]="userPromptLookupTemplate"
          (inputChanged)="onUserPromptLookup($event)"
          (selected)="getPromptDetail($event)"
        >
        </gtapp-auto-complete>
        <ng-template #userPromptLookupTemplate let-item>
          <div>{{ item?.name }}</div>
        </ng-template>
      </div>
    }
  </div>

  <gtapp-card-list
    [mobileCardBackendData]="userPromptList"
    [mobileCardDetails]="promptCardDetails"
    [mobileActionIcons]="cardIcons"
    [otherParams]="otherParamsUserPrompt"
    (actionClick)="actionClick($event, copyPromptTemplateRef)"
    (rowClick)="getPromptDetail($event)"
    (paginationChange)="onChangePagination($event)"
  ></gtapp-card-list>
  <ng-template
    #copyPromptTemplateRef
    let-copyPromptTemplateRef="dialogRef"
    let-data
  >
    <div class="card dialog-box">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        Duplicate Form
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="copyPromptTemplateRef.close()"
        ></button>
      </div>
      <div>
        <div class="form-floating my-3">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="promptName"
            placeholder="Mobile Form Name"
            id="promptNameInput"
          />
          <label for="promptNameInput">Mobile Form Name</label>
        </div>
        <div class="row row-cols-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-dark btn-lg w-100"
              (click)="copyPromptTemplateRef.close()"
            >
              Cancel
            </button>
          </div>
          <div
            class="col"
            (click)="
              onConfirmCopy(data?.data?.id); copyPromptTemplateRef.close()
            "
          >
            <button type="button" class="btn btn-primary btn-lg w-100">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
